var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-wrapper m-b-16"},[(_vm.step)?_c('img',{attrs:{"src":require(("../../assets/images/premium/step_" + _vm.step + ".png"))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }